let scrollAnimId = null;

Math.easeInOutQuad = function (t, b, c, d) {
  t /= d/2;
  if (t < 1) {
    return c/2*t*t + b
  }
  t--;
  return -c/2 * (t*(t-2) - 1) + b;
};

const requestAnimFrame = (function() {
  return window.requestAnimationFrame
         || window.webkitRequestAnimationFrame
         || window.mozRequestAnimationFrame
         || function(callback) { window.setTimeout(callback, 1000 / 60); };
})();


/**
 * Handle "scroll to" animation
 * @param {number}   to       - Absolute Y coordinate to go
 * @param {number}   duration - Duration of the animation (ms)
 * @param {function} callback - Function to call at the end of the animation
 */
export function scrollTo(to, anchor, duration, callback) {
  // because it's so fucking difficult to detect the scrolling element, just move them all
  function anchorScroll(anchor, amount) {
    if (anchor == document.body) {
      document.documentElement.scrollTop = amount;
      document.body.parentNode.scrollTop = amount;
      document.body.scrollTop            = amount;
    } else {
      anchor.scrollTop = amount;
    }
  }
  let currentTime        = 0;
  const stepLength       = 20;
  anchor                 = (typeof(anchor) === 'undefined') ? document.body : anchor;
  duration               = (typeof(duration) === 'undefined') ? 500 : duration;
  const currentScrollTop = (anchor == document.body)
    ? (window.pageYOffset || document.documentElement.scrollTop || document.body.parentNode.scrollTop || document.body.scrollTop)
    : anchor.scrollTop;
  const absTo            = (anchor == document.body) ? to - anchor.getBoundingClientRect().top : to;
  const change           = (anchor == document.body) ? absTo - currentScrollTop : absTo;

  const animateScroll = () => {
    currentTime += stepLength;
    // find the value with the quadratic in-out easing function
    const value = Math.easeInOutQuad(currentTime, currentScrollTop, change, duration);
    // move the document.body
    anchorScroll(anchor, value);
    // do the animation unless its over
    if (currentTime < duration)
      scrollAnimId = requestAnimFrame(animateScroll);
    else {
      scrollAnimId = null;
      if (callback && typeof(callback) === 'function') callback();
    }
  };
  animateScroll();
}

export function scrollToIfNotVisible(to, anchor, duration, callback) {
  const screenHeight = window.innerHeight
                       || document.documentElement.clientHeight
                       || document.body.clientHeight;
  if (to < 0 || to > screenHeight)
    scrollTo(to, anchor, duration, callback);
}

const defaultAnimateOptions = {
  time: 300,
};

/**
 * Animate DOM element
 * @param {object}   element   - DOM element to animate
 *
 * @param {array}    styles     - Style property concerned by the animation
 * @param {number}   from      - Origin of the animation
 * @param {number}   to        - Destination of the animation
 *
 * @param {number}   time      - Animation duration in ms
 * @param {object}   callbacks - callback called when animation beginning
 */
export function animate(element, styles, options= {}) {
  options = Object.assign({}, defaultAnimateOptions, options);
  if (!element) return;
  let start = null;

  function setStyle(style, styleValue) {
    (['translateX', 'translateY'].indexOf(style.type) == -1)
      ? element.style[style.type] = styleValue
      : element.style.transform = style.type+'('+styleValue+')';
  }

  function step() {
    if (!start) {
      start = (window.performance.now)
        ? (performance.now() + performance.timing.navigationStart)
        : Date.now();
      if (options.beginCallback) options.beginCallback.call(this);
    }
    let currentTime = (window.performance.now)
      ? (performance.now() + performance.timing.navigationStart)
      : Date.now();
    // Modify the elements that we animate
    let animStep = Math.min(1, (currentTime-start)/options.time);

    styles.forEach( style => {
      const styleValue = (style.from + animStep * (style.to - style.from)) + style.unit;
      setStyle(style, styleValue);
    })
    if (animStep < 1)
      requestAnimFrame(step);
    else
      if (options.completeCallback) options.completeCallback.call(this);
  }
  requestAnimFrame(step);
}



// WEBPACK FOOTER //
// ./assets/javascripts/helpers/animations_helper.js